import React from 'react'
import Flex from 'typescript-styled-flex'
import { Divider, IconButton } from '@material-ui/core'
import { FiTrash } from 'react-icons/fi'

function ProvenanceItem({ label, onDelete, size = 1 }) {
  return (
    <React.Fragment>
      <Flex
        full={true}
        alignCenter={true}
        justifyBetween={true}
        style={{
          marginBottom: `${10 * size}px`,
          overflow: 'hidden',
          paddingRight: `${15 * size}px`,
        }}
      >
        <div
          style={{
            fontSize: `${16 * size}px`,
            outline: 'none',
            overflowWrap: 'break-word',
            wordBreak: 'break-all',
          }}
        >
          {label}
        </div>
        <IconButton style={{ padding: `${12 * size}px` }} onClick={onDelete}>
          <FiTrash color={'red'} size={18 * size} />
        </IconButton>
      </Flex>
      <Divider
        style={{
          margin: `${5 * size}px 0px`,
          textAlign: 'left',
          width: `calc(100% - ${16 * size}px)`,
        }}
      />
    </React.Fragment>
  )
}

export default ProvenanceItem
